import { z } from 'zod';
import { HomeSlotBaseDTO } from '../HomeSlotBaseDTO';
import { HomeSlotDTOTypes } from '../HomeSlotDTOTypes';

export type HomeProductsListDTO = z.infer<typeof HomeProductsListDTO>;
export const HomeProductsListDTO = HomeSlotBaseDTO.extend({
    type: HomeSlotDTOTypes.ProductsList,
});
